export const sources={};export const img={src:"__VITE_ASSET__pADEGV0e5Qot5ZhzD_GrLg__",w:640,h:640};export default{sources:sources,img:img};